var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    viewBox: "0 0 184 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1003_6243)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 184,
    fill: "#F3BA2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 169C127.333 169 173 123.333 173 67C173 10.6669 127.333 -35 71 -35C14.667 -35 -31 10.6669 -31 67C-31 123.333 14.667 169 71 169Z",
    fill: "#F3BA2F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92 66.244L73.7445 84.4995L63.1232 73.8768L92 45L120.886 73.8855L110.264 84.5075L92 66.244ZM55.6224 81.3761L45 92L55.6216 102.62L66.244 91.9978L55.6224 81.3761ZM73.7445 99.5016L92 117.756L110.264 99.493L120.891 110.109L120.886 110.115L92 139L63.1232 110.123L63.1082 110.108L73.7445 99.5016ZM128.378 81.3821L117.756 92.0045L128.378 102.626L139 92.0038L128.378 81.3821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.773 91.9943H102.778L91.9999 81.2159L84.0336 89.18L83.1184 90.0955L81.2309 91.9834L81.2158 91.9981L81.2309 92.0135L91.9999 102.784L102.778 92.0056L102.784 91.9996L102.773 91.9943Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1003_6243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 184,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.99895ff13cc220dccf7c9236aa54c2d1.svg";
export { ForwardRef as ReactComponent };